import { useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { faqs } from '@/mocks/content';

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(faqs[0]?.id ?? null);

  const toggle = (id: number) => setOpenId((prev) => (prev === id ? null : id));

  return (
    <section id="faq" className="py-12 md:py-16 scroll-mt-20 bg-background-100/70">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-5 dv-reveal">
            <SectionHeading
              kicker="常见问题"
              title="常见问题：关于本站，你可能想知道的"
              desc="如果下面没有你想问的，也可以到社区讨论区里看看别人的提问经验。"
            />
            <div className="mt-5 rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-2 text-primary-700">
                <i className="ri-information-line text-lg" />
                <span className="text-sm font-semibold">一句话总结</span>
              </div>
              <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                本站是内容导览，把热门推荐、福利主播、无删减合集和社区讨论整理成一页，方便你快速发现想看的作品。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col gap-3 dv-reveal">
            {faqs.map((item) => {
              const open = openId === item.id;
              return (
                <div
                  key={item.id}
                  className={`rounded-lg border transition-colors ${
                    open ? 'border-primary-300 bg-background-50' : 'border-background-200 bg-background-50'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggle(item.id)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left cursor-pointer md:px-5"
                  >
                    <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 flex-none flex items-center justify-center rounded-full text-lg transition-colors ${
                        open ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'} />
                    </span>
                  </button>
                  {open ? (
                    <div className="px-4 pb-4 md:px-5">
                      <p className="text-xs md:text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}